import React, { useEffect, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import './Modal.css';
import useKeyPress from '../../../hooks/useKeyPress';

function ModalButton({ label, className, onClick = () => {}, cancelClick, keyPress = false, autoCancel = true }) {
  let keyValid = useKeyPress('Enter');
  let [lock, setLock] = useState(false);
  const click = useCallback(() => {
    onClick();
    if (cancelClick && autoCancel) { cancelClick(); }
  }, [onClick, cancelClick, autoCancel]);
  useEffect(() => {
    if (keyPress && keyValid && !lock) {
      setLock(true);
      click();
    }
  }, [keyValid, keyPress, click, lock]);

  return <div className={`cta ${className}`} onClick={click}>{label}</div>
}

ModalButton.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  cancelClick: PropTypes.func,
  keyPress: PropTypes.bool,
  autoCancel: PropTypes.bool
}

export default ModalButton;
